import { render, staticRenderFns } from "./DictationEdit.vue?vue&type=template&id=566fe608&scoped=true&"
import script from "./DictationEdit.vue?vue&type=script&lang=js&"
export * from "./DictationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566fe608",
  null
  
)

export default component.exports